import { RoleId } from '@wix/members-domain-ts';
import { unreachable } from '../../ts-utils';
import { MemberRole } from '../../controller/services/comments-service';
export const mapMemberRoleToMaRole = (role) => {
    switch (role) {
        case MemberRole.OWNER:
            return RoleId.ADMIN;
        case MemberRole.CONTRIBUTOR:
            return RoleId.ADMIN;
        case MemberRole.BLOCKED:
            return RoleId.BLOCK_MEMBER;
        case MemberRole.BLOG_WRITER:
            return RoleId.SET_BLOG_WRITER;
        case MemberRole.BLOG_EDITOR:
            return RoleId.SET_BLOG_EDITOR;
        case MemberRole.FORUM_MODERATOR:
            return RoleId.SET_FORUM_MODERATOR;
        case MemberRole.UNKNOWN_ROLE:
            return undefined;
        default:
            throw unreachable(role);
    }
};
//# sourceMappingURL=map-member-role-to-ma-role.js.map